<template>
  <div class="box">
    <div class="container">
      <div class="content">
        <div class="data-box" id="data-on">
          <div
            class="con-box"
            v-for="(item, index) in OrganizingList"
            :key="item.id"
            @click="handleOrganizing(item, index)"
          >
            <div class="img-box">
              <img :src="item.src" />
            </div>
            <div class="txt-box">
              <span class="name">{{ $t(item.name) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Dataintroduction',
  components: {},
  mounted() {},
  data() {
    return {
      OrganizingList: [
        { id: 1, name: '创建专属赛事官网', src: require('../../../assets/dataicon/1.png') },
        { id: 2, name: '赛事数据永久保存', src: require('../../../assets/dataicon/2.png') },
        { id: 3, name: '智能报名规避错报', src: require('../../../assets/dataicon/3.png') },
        { id: 4, name: '一键抽签编排', src: require('../../../assets/dataicon/4.png') },
        { id: 5, name: '一键下载秩序册、对战表', src: require('../../../assets/dataicon/5.png') },
        { id: 6, name: '智能检录呼叫号码', src: require('../../../assets/dataicon/6.png') },
        { id: 7, name: '智能竞赛设备', src: require('../../../assets/dataicon/7.png') },
        { id: 8, name: '成绩实时云同步', src: require('../../../assets/dataicon/8.png') },
        { id: 9, name: '一键制作参赛证奖状', src: require('../../../assets/dataicon/9.png') },
        { id: 10, name: '参数数据、技术分析', src: require('../../../assets/dataicon/10.png') },
      ],
    }
  },
  computed: {},
  methods: {
    handleOrganizing(item, index) {
      this.$router.push({
        name: 'Service',
        params: {
          index: 0,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  position: relative;
  top: -70px;
}
.container {
  width: 100%;
  height: 320px;
  background-image: url('../../../assets/databg.png');
  background-repeat: no-repeat;
  background-size: 100% 120%;
  position: relative;
  top: -130px;
  padding-bottom: 70px;
}
.content {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
}
.con-box {
  width: 160px;
  float: left;
  margin-right: 80px;
  text-align: center;
  cursor: pointer;
}

.img-box {
  width: 80px;
  height: 50px;
  text-align: center;
  display: inline-block;
  margin: 0 auto;
}
.txt-box {
  width: 160px;
  height: 90px;
  margin-top: 30px;
  .name {
    font-weight: bold;
    font-size: 14px;
  }
}
.data-box {
  overflow: hidden;
  position: absolute;
  width: 1200px;
  left: -2000px;
  top: 100px;
  transition: 0.5s;
}
.data-on-box {
  overflow: hidden;
  position: absolute;
  width: 1200px;
  left: 0;
  top: 100px;
  transition: 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/components/Dataintroduction.vue